/* src/app/gui/components/toasts/toasts.component.css */
.message-body {
  flex-grow: 1;
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=toasts.component.css.map */
